// Put your application javascript here

document.addEventListener('DOMContentLoaded', function() {

  // WCP Override things
  if (document.querySelector('.template--cart')) {
    let waitFor = setInterval(function() {
      const el = document.querySelector('.wcp-hero-wcpModal')
      if (el) {
        //console.log('waiting...')
        el.classList.remove('wcp-hero-wcpModal')
        clearInterval(waitFor);
       }
    }, 500);

    // const priceEl = document.querySelector('.wcp-cart-total')
    // var observer = new MutationObserver(function(mutationsList, observer) {
    //   for(var mutation of mutationsList) {
    //     if (mutation.type == 'childList') {
    //       console.log('watch paragraph has changed or child has been added/removed')
    //       observer.disconnect()
    //       setTimeout(function() {
    //         console.log(priceEl.innerHTML.split('.')[0])
    //         priceEl.innerHTML = priceEl.innerHTML.split('.')[0]
    //         console.log(priceEl.innerHTML)
    //       }, 1500)
    //     }
    //   }
    // })
    // observer.observe(priceEl, { childList: true })
  }

  /*
  [].forEach.call(document.querySelectorAll('.filter-trigger'), function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault()
      const newFilter = this.getAttribute('data-filter')
      if (document.body.className.indexOf(newFilter) < 0) {
        document.body.className = document.body.className.replace(/filter--[^\s]+/g, '')
        document.body.classList.add(`filter--${newFilter}`)
      } else {
        document.body.className = document.body.className.replace(/filter--[^\s]+/g, '')
      }
    })
  })
  */

  /*
  let stockists = document.querySelector('[data-parent="stockists"]')
  if (stockists) {
    let chunks = []
    stockists && [].forEach.call(stockists.querySelectorAll('h2'), function(el) {
      let div = document.createElement('div')
      div.append(el, el.nextElementSibling)
      chunks.push(div)
    })

    stockists.innerHTML = ''
    chunks.forEach(function(chunk) {
      stockists.appendChild(chunk)
    })
  }
  */

  ;[].forEach.call(document.querySelectorAll('.page-link'), function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault()
      document.body.classList.add('open--secondary-menu')
      document.querySelector('.info').classList.remove('inactive')
      document.querySelector('.secondary-menu').classList.add('inactive')
      ;[].forEach.call(document.querySelectorAll('*[data-parent]'), function(el) {
        el.classList.remove('active')
      })
      document.querySelector(`*[data-parent="${this.getAttribute('data-parent-trigger')}"]`).classList.add('active')
    })
  })

  ;[].forEach.call(document.querySelectorAll('.inner-page-link'), function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault()
      ;[].forEach.call(document.querySelectorAll('*[data-inner-page]'), function(el) {
        el.classList.remove('active')
      })
      document.querySelector(`*[data-inner-page="${this.getAttribute('data-inner-page-trigger')}"]`).classList.add('active')
      document.querySelector('[data-parent="range"]').scrollTo(0, 0)
    })
  })

  ;[].forEach.call(document.querySelectorAll('.nav-link'), function(el) {
    el.addEventListener('click', function(e) {
      document.body.classList.add('open--secondary-menu')
      document.querySelector('.secondary-menu').classList.remove('inactive')
      document.querySelector('.info').classList.add('inactive')

      if (document.querySelector(`*[data-link="${this.getAttribute('data-nav-trigger')}"]`).classList.contains('active')) {
        document.location.href = this.getAttribute('data-url')
        return true
      }

      e.preventDefault()
      let level = this.getAttribute('data-level-trigger')
      ;[].forEach.call(document.querySelectorAll('*[data-level]'), function(el) {
        el.classList.remove('active')
      })

      let target = document.querySelector('*[data-level="'+level+'"]')
      while (level > 0) {
        document.querySelector('*[data-level="'+level+'"]').classList.add('active')
        level--
      }
      ;[].forEach.call(target.querySelectorAll('*[data-link]'), function(el) {
        el.classList.remove('active')
      })
      document.querySelector(`*[data-link="${this.getAttribute('data-nav-trigger')}"]`).classList.add('active')
    })
  })

  document.body.addEventListener('click', async function(e) {
    if (e.target.matches('.open-primary-menu')) {
      e.preventDefault()
      document.body.classList.remove('open--secondary-menu')
    }
  })

  const currentLink = document.querySelector('.primary-menu a[data-url="'+document.location.pathname+'"]')
  if (currentLink) {
    console.log(currentLink)
    currentLink.dispatchEvent(new Event('click'))
  }
  
  
  /*
  function reloadHTML(html, selector) {
    var temp = document.createElement('DIV')
    temp.innerHTML = html
    var el = temp.querySelector(selector);
    document.querySelector(selector).innerHTML = el.outerHTML;
    temp.innerHTML = ''
  }

  async function reloadCart() {
    const r = await fetch('/cart', {
      credentials: 'include',
      method: 'GET'
    })
    const response = await r.text()

    reloadHTML(response, '.cart-counter')
    reloadHTML(response, '.checkout')
  }

  if (document.querySelector('.add-to-cart')) {
    document.querySelector('.add-to-cart').addEventListener('submit', async function(e) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch('/cart/add.js', {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify(Object.fromEntries(new FormData(this))),
        method: 'POST'
      })
      const response = await r.text()

      if (response.toLowerCase().indexOf('error') > -1) {
        var json = JSON.parse(response)
        document.querySelector('.add-to-cart__message').innerHTML = 
          `<h3>Notification</h3>
           <p>${json['description']}</p>`
        document.body.classList.add('show--error')
        document.body.classList.remove('cart--in-progress')
        setTimeout(function() {
          document.body.classList.remove('show--error')
          document.querySelector('.add-to-cart__message').innerHTML = ''
        }, 4 * 1000)
      } else {
        await reloadCart()
        document.querySelector('.add-to-cart__success').innerHTML = 
          `<h3>Notification</h3>
           <p>Successfully added.</p>`
        document.body.classList.add('show--success')
        document.body.classList.remove('cart--in-progress')
        setTimeout(function() {
          document.body.classList.remove('show--success')
          document.querySelector('.add-to-cart__success').innerHTML = ''
        }, 4 * 1000)
      }
    })
  }


  document.body.addEventListener('change', async function(e) {
    if (e.target.matches('.item-quantity')) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch('/cart/change.js?line='+e.target.getAttribute('data-line')+'&quantity='+e.target.value, {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      await reloadCart()
      document.body.classList.remove('cart--in-progress')
    }
  })

  document.body.addEventListener('click', async function(e) {
    if (e.target.matches('.open-primary-menu')) {
      e.preventDefault()
      document.body.classList.remove('open--secondary-menu')
    }
    else if (e.target.matches('.remove-link')) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch(e.target.href.replace('change', 'change.js'), {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      await reloadCart()
      document.body.classList.remove('cart--in-progress')
    }
  })
  */

  /*
  ;[].forEach.call(document.querySelectorAll('.remove-link'), function(el) {
    el.addEventListener('click', async function(e) {
      e.preventDefault()
      document.body.classList.add('cart--in-progress')

      const r = await fetch(this.href.replace('change', 'change.js'), {
        credentials: 'include',
        headers: {
          'content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'xmlhttprequest'
        },
        method: 'GET'
      })
      const response = await r.text()
      reloadCart()
      document.body.classList.remove('cart--in-progress')
    })
  })
  */

}, false)
